const BASE_PATH = "/api/v1";

export const buildAPIQuery = (pathValue, apiParams, formAttributeColumns) => {
  const { urlPath, hasObjectId, hasAdditionalParams, payload = {} } = apiParams;
  let url = `${BASE_PATH}/${pathValue}`;
  if (urlPath) url += `/${urlPath}`;
  if (hasObjectId) url += "/{object-id}";

  let newPayload = { ...payload };
  if (hasAdditionalParams) {
    newPayload = Object.assign(
      newPayload,
      ...formAttributeColumns.map((column) => ({ [column]: "" }))
    );
  }

  // Update URL, payload
  return { ...apiParams, url, payload: newPayload };
};
